import client from "./client";

export type FieldType =
  | "text"
  | "number"
  | "dropdown"
  | "date"
  | "checkbox"
  | "textarea"
  | "email"
  | "phone";

export interface CustomFieldDefinition {
  id: string;
  org_id: string;
  field_name: string;
  field_key: string;
  field_type: FieldType;
  options: string[] | null;
  is_required: boolean;
  is_visible_to_employee: boolean;
  is_editable_by_employee: boolean;
  category: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CustomFieldCreateInput {
  field_name: string;
  field_key: string;
  field_type: FieldType;
  options?: string[] | null;
  is_required?: boolean;
  is_visible_to_employee?: boolean;
  is_editable_by_employee?: boolean;
  category?: string;
  sort_order?: number;
  is_active?: boolean;
}

export type CustomFieldUpdateInput = Partial<CustomFieldCreateInput>;

export interface CustomFieldValueItem {
  field_id: string;
  field_key: string;
  field_name: string;
  field_type: FieldType;
  category: string;
  options: string[] | null;
  is_required: boolean;
  is_visible_to_employee: boolean;
  is_editable_by_employee: boolean;
  value: string | null;
  parsed_value: string | number | boolean | null;
  updated_at: string | null;
  updated_by: string | null;
}

export interface CustomFieldValueList {
  employee_id: string;
  values: CustomFieldValueItem[];
}

export async function listDefinitions(
  includeInactive = false,
): Promise<CustomFieldDefinition[]> {
  const res = await client.get("/custom-fields", {
    params: { include_inactive: includeInactive },
  });
  return res.data;
}

export async function createDefinition(
  input: CustomFieldCreateInput,
): Promise<CustomFieldDefinition> {
  const res = await client.post("/custom-fields", input);
  return res.data;
}

export async function updateDefinition(
  id: string,
  input: CustomFieldUpdateInput,
): Promise<CustomFieldDefinition> {
  const res = await client.put(`/custom-fields/${id}`, input);
  return res.data;
}

export async function deleteDefinition(id: string): Promise<void> {
  await client.delete(`/custom-fields/${id}`);
}

export async function fetchEmployeeValues(
  employeeId: string,
): Promise<CustomFieldValueList> {
  const res = await client.get(`/employees/${employeeId}/custom-fields`);
  return res.data;
}

export async function updateEmployeeValues(
  employeeId: string,
  values: Record<string, unknown>,
): Promise<CustomFieldValueList> {
  const res = await client.put(`/employees/${employeeId}/custom-fields`, {
    values,
  });
  return res.data;
}

export async function fetchMyValues(): Promise<CustomFieldValueList> {
  const res = await client.get("/my/custom-fields");
  return res.data;
}

export async function updateMyValues(
  values: Record<string, unknown>,
): Promise<CustomFieldValueList> {
  const res = await client.put("/my/custom-fields", { values });
  return res.data;
}
